<template>
    <div class="row justify-content-center">
        <div class="col-xl-10">
            <div class="uploader-container uploader-container--images">
                <div v-if="sended" class="compress-result component-sended--wrapper">
                    <div class="row row-min-height align-items-center">
                        <div class="col-12 text-center" v-show="!sendError && !completed">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">{{ trans('tool-main.Processing text') }}</span>
                            </div>
                            <h4>{{ trans('tool-main.Processing text') }}</h4>
                            <button class="btn btn-lg btn-info cancel-btn_tool" @click="cancelSendTask()">
                                {{ trans('tool-main.Cancel') }}
                            </button>
                        </div>
                        <div class="col-12" v-if="!sendError && completed">
                            <h2 class="title compress-result_title">{{ trans('pdf/tool-translate.Image ready') }}</h2>

                            <div class="row" v-if="downloadUrl">
                                <div class="col-md-12 ">
                                    <VueDocPreview :value="downloadUrl" type="office"/>
                                </div>
                            </div>

                            <div class="compress-result_action">
                                <div class="compress-result_action-group">
                                    <div class="compress-result_tools mt-4">
                                        <upload-block
                                            type-block="new-compact"
                                            :downloadUrl="downloadUrl"
                                            :dropboxFiles="dropboxFiles"
                                            :downloadFileInfo="downloadFileInfo"
                                            @onCancelDropbox="onCancelDropbox"
                                            @onErrorDropbox="onErrorDropbox"
                                            @onProgressDropbox="onProgressDropbox"
                                            @onSavedDropbox="onSavedDropbox"
                                            @markAsDownloaded="markAsDownloaded"
                                            ref="uploadBlock"/>

                                        <other-tools-block
                                            :task-id="this.taskId"
                                            :file-link="downloadUrl"
                                        ></other-tools-block>

                                        <div class="compress-result_tools-item">
                                            <button class="button compress-result_button-link"
                                                    @click="cancelSendTask()">
                                                {{ trans('tool-main.Keep Editing') }}
                                            </button>
                                            <button class="button compress-result_button-link" @click="reset()">
                                                {{ trans('tool-main.Start Over') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row align-items-stretch small_gutter">
                                <div class="col-lg-4 mt_25">
                                    <qr-block :url="downloadUrl"
                                              :task-id="taskId"
                                              :type="loaderType"
                                              :mode="loaderMode"
                                    ></qr-block>
                                </div>

                                <div class="col-lg-8 mt_25">
                                    <subscribe-block></subscribe-block>
                                    <share-icons-block></share-icons-block>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center" v-show="sendError">
                            <h5 class="mb-4" v-html="sendError"></h5>
                            <button class="btn btn-secondary" @click="cancelSendTask()">
                                {{ trans('tool-main.Back') }}
                            </button>
                            <button class="btn btn-outline-secondary ml-3" @click="reset()">
                                {{ trans('tool-main.Start Over') }}
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="files.length === 0" class="file-uploader--wrapper">
                    <file-uploader
                        :type="loaderType"
                        :mode="loaderMode"
                        :multiple="false"
                        :maxFiles="1"
                        @files-uploaded="updateFiles($event)"
                    />
                </div>
                <div v-if="files.length > 0 && !sended"
                     class="component--wrapper">

                    <div class="card-body custom-scroll">
                        <pdf-preview v-bind="{inputFiles: files, scale, mode, selectable: false, rotated: false}"
                                     ref="viewer"
                                     @loaded="onPdfPreviewLoaded"
                                     @invalid-file="onInvalidFile"/>
                    </div>
                    <div class="card-footer">
                        <div class="form-row w-100 m-u align-items-center justify-content-center">
                            <div class="form-group col-md-3 offset-md-2">
                                <label for="inputLanguage">{{
                                        trans('pdf/tool-translate.Input Language select')
                                    }}</label>
                                <Select2 v-model="inputLanguage"
                                         :options="ocrLanguages"
                                         :settings="{ multiple: false, }"
                                         :placeholder="trans('pdf/tool-translate.Input Language placeholder')"
                                         id="inputLanguage"
                                />
                            </div>
                            <div class="form-group col-md-3">
                                <label for="outputLanguage">{{
                                        trans('pdf/tool-translate.Output Language select')
                                    }}</label>
                                <Select2 v-model="outputLanguage"
                                         :options="translateLanguages"
                                         :settings="{ multiple: false, }"
                                         :placeholder="trans('pdf/tool-translate.Output Language placeholder')"
                                         id="outputLanguage"
                                />
                            </div>
                            <div class="col-md-4 text-md-left">
                                <button type="button" class="btn btn-primary" @click="checkAndSendTask()"
                                        :disabled="files.length < 1 || this.sended || !this.previewLoaded"
                                >
                                    {{ trans('pdf/tool-translate.Translate btn') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.component--wrapper.component--wrapper__image-box-preview {
    width: 100%;
}

.component--wrapper.component--wrapper__image-box-preview img {
    width: inherit;
}
</style>

<script>
import markAsDownloaded from '../mixins/mark-as-downloaded.js';
import baseProcessing from '../mixins/base-processing.js';
import pdfScale from '../mixins/pdf-scale.js';
import Select2 from '../shared/select2/Select2';
import VueDocPreview from 'vue-doc-preview';

export default {
    props     : [
        'loaderMode',
    ],
    mixins    : [
        pdfScale,
        markAsDownloaded,
        baseProcessing,
    ],
    components: {
        'share-icons-block': () => import(/* webpackChunkName: 'result-blocks' */ '../shared/ShareIconsBlock'),
        'subscribe-block'  : () => import(/* webpackChunkName: 'result-blocks' */ '../shared/SubscribeBlock'),
        'other-tools-block': () => import(/* webpackChunkName: 'result-blocks' */ '../shared/OtherToolsBlock'),
        'pdf-preview'      : () => import(/* webpackChunkName: 'pdf' */ './elements/PDFPreview.vue'),
        'file-uploader'    : () => import(/* webpackChunkName: 'fileuploader' */ '../uploader/FileUploader.vue'),
        'upload-block'     : () => import(/* webpackChunkName: 'uploadBlock' */ '../uploader/UploadBlock.vue'),
        'qr-block'         : () => import(/* webpackChunkName: 'qr-block' */ '../shared/QrBlock.vue'),
        Select2,
        VueDocPreview,
    },
    data() {
        let ocrOptions       = [],
            translateOptions = [];

        if (window.ocrLanguages) {
            Object.keys(window.ocrLanguages).forEach(index => {
                ocrOptions.push({
                    'id'  : index,
                    'text': window.ocrLanguages[index],
                });
            });
        }

        if (window.translateLanguages) {
            Object.keys(window.translateLanguages).forEach(index => {
                translateOptions.push({
                    'id'  : index,
                    'text': window.translateLanguages[index],
                });
            });
        }

        return {
            files             : [],
            loaderType        : 'pdf',
            inputLanguage     : 'auto',
            outputLanguage    : 'English',
            password          : '',
            ocrLanguages      : ocrOptions,
            translateLanguages: translateOptions,
            previewLoaded     : false,
            mode              : 'group_pages',

        }
    },
    methods: {
        updateFiles(files) {
            this.files = files;
        },

        onInvalidFile(file_id) {
            let index = this.files.findIndex(file => file.file_id == file_id);

            if (index > -1) {
                this.files.splice(index, 1);
            }
        },

        onPdfPreviewLoaded() {
            this.files.forEach((item) => {
                if (item.password) {
                    this.password = item.password;
                }
            });

            this.previewLoaded = true;
        },

        checkAndSendTask() {
            Vue.nextTick(() => this.sendTask());
        },

        prepareTaskData() {
            this.taskUrl = '/' + this.loaderType + '/prepare';
            return {
                mode          : this.loaderMode,
                files         : this.files,
                input_language: this.inputLanguage ? this.inputLanguage : 'auto',
                target        : this.outputLanguage ? this.outputLanguage : 'English',
                password      : this.password,
            };
        },

        afterReset() {
            // default values
            this.files = [];
            this.inputLanguage = 'auto';
            this.outputLanguage = 'English';
            this.password = '';
            this.previewLoaded = false;
        },
    },
}
</script>
